import { PaymentFee, PaymentFeeIdEnum } from '@qvs/core';

export const paymentFees: PaymentFee[] = [
  { id: PaymentFeeIdEnum.SHARED, name: 'payments.FEE_NAME_SHARED', description: 'payments.FEE_DESCRIPTION_SHARED' },
  {
    id: PaymentFeeIdEnum.BENEFICIARY,
    name: 'payments.FEE_NAME_BENEFICIARY',
    description: 'payments.FEE_DESCRIPTION__BENEFICIARY'
  },
  { id: PaymentFeeIdEnum.SENDER, name: 'payments.FEE_NAME_SENDER', description: 'payments.FEE_DESCRIPTION__SENDER' }
];
